import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Film, LogIn } from 'lucide-react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '@/firebase';

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.currentUser) {
      navigate('/');
    }
  }, [navigate]);

  const handleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate('/');
    } catch (error) {
      console.error('Firebase Google login failed:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative" style={{ backgroundImage: 'url(https://images.pexels.com/photos/7991158/pexels-photo-7991158.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="absolute inset-0 bg-black/70" />
      <div className="relative z-10 glass rounded-2xl p-12 max-w-md w-full mx-4" data-testid="login-card">
        <div className="text-center">
          <div className="flex justify-center mb-6"><Film className="w-16 h-16 text-primary" /></div>
          <h1 className="font-heading text-4xl font-bold tracking-tight mb-2">AfterCredits</h1>
          <p className="text-muted-foreground mb-8">Where conversations begin after the credits roll</p>
          <button onClick={handleLogin} className="w-full bg-primary text-primary-foreground px-8 py-4 rounded-full font-semibold text-lg btn-glow hover:opacity-90 transition-all active:scale-95 flex items-center justify-center space-x-2" data-testid="google-login-button"><LogIn className="w-5 h-5" /><span>Sign in with Google</span></button>
          <p className="text-xs text-muted-foreground mt-6">Discover, discuss, and share your favorite movies</p>
        </div>
      </div>
    </div>
  );
}
